import React, {useEffect, useState} from "react"
import {useMessage, useModal, useProgress, useLocal, useSolution, useSolutionRepository} from "../AppContext"
import {ShareIcon, ShareText} from "./ShareIcon"
import {hasUrlFlag, URL_FLAG__LIGHTVERSION} from "../Helper/UrlFlag"
import {Clipboard} from "./Clipboard"
import {Button, ButtonShy} from "./Button"
import {RoomName} from "./RoomName"
import {solutionDispatchShare} from "../Modal/SolutionRepository"
import {logo, threedplaner, iconWorld, iconHelp, iconLogin, iconLoad, iconSave, iconHeadset, iconSwitch, iconDisabled ,iconEnabled} from "../Helper/Icons"
import style from "./MenuTop.css"
import { logoSettings } from "../settings"

export const MenuTop = () => {
    return <div className={style.container}>
        <div className={style.left}>
            <Logo/>
        </div>
        <div className={style.menu}>
            <Code/>
            {/*<Lang/>*/}
            <Switch/>
            <Load/>
            <Save/>
            {/*<Account/>*/}
            <Consult/>
            <Help/>
            <Tutorial/>
        </div>
    </div>
}

export const MenuTopSimple = () => {
    return <div className={style.container}>
        <div className={style.left}>
            <Logo/>
        </div>
        <div className={style.menu}>
            <Help/>
        </div>
    </div>
}

const Logo = () => {
    const local = useLocal()

    return <div className={style.logo}>
        <div><a href={logoSettings.href} rel="noopener noreferrer" target="_blank">{logo}</a></div>
        <div>{threedplaner}</div>
    </div>
}

const Code = () => {
    const local = useLocal()
    const solution = useSolution()

    if (!solution.getCode()) {
        return null
    }

    return <div className={style.cta}>
        <ShareText>
            <div>{local.__("Jederzeit weiter planen mit dem Raumcode:")}</div>
        </ShareText>
        <ShareText>
            <div className={style.code}>{solution.getCode()}</div>
        </ShareText>
        <ShareIcon/>
        <Clipboard code={solution.getCode()}/>
    </div>
}

const Lang = () => {
    const local = useLocal()
    const [select, setSelect] = useState(false)
    const className = select ? `${style.menuItem} ${style.active}` : style.menuItem

    const close = () => {
        setSelect(false)
    }

    const toggleLanguage = () => {
        setSelect(select => !select)
    }

    const Language = () => {
        const local = useLocal()
        return <div className={style.select}>
            {local.getLangList().map((lang, index) => {
                return <div key={index} onClick={() => local.setLang(lang.code)}>{lang.name}</div>
            })}
        </div>
    }

    useEffect(() => {
        if (!select) return

        document.addEventListener("click", close)
        return () => {
            document.removeEventListener("click", close)
        }
    }, [select])

    return <div className={className} onClick={toggleLanguage}>
        {iconWorld}
        {local.getLangInfo().nameShort}
        {select && <Language/>}
    </div>
}

const Save = () => {
    const local = useLocal()
    const modal = useModal()
    const progress = useProgress()
    const className = progress.isRoom()
        ? `${style.menuItem} ${style.disabled}`
        : style.menuItem

    const click = () => {
        if (!progress.isRoom()) {
            modal.openSolutionSave()
        }
    }

    return <div className={className} onClick={click}>
        {iconSave}
        {local.__("Raum speichern")}
    </div>
}

const Switch = () => {
    const local = useLocal()
    const modal = useModal()
    const message = useMessage()
    const progress = useProgress()
    var lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
    const [state, setState] = useState(lightversion);
    
    const click = () => {
        var lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
        //if (progress.isSolution()) {
            if (!lightversion){
                message.showSuccess(local.__("Sie befinden sich jetzt in der Schnellplanung."))
            }else{
                message.showSuccess(local.__("Sie befinden sich jetzt in der Detailplanung."))
            }
        //}
        var url = new URL(window.location.href);
        var parameter = "light";
        if (!lightversion){
          lightversion=true;
          setState(lightversion);
          url.searchParams.set(parameter, '1');
        }else{
          url = new URL(window.location.href)+'';
          lightversion=false;
          setState(lightversion);
          var urlparts= url.split('?');   
          
          if (urlparts.length>=2) {
              var prefix= encodeURIComponent(parameter)+'=';
              var pars= urlparts[1].split(/[&;]/g);
              
              //reverse iteration as may be destructive
              for (var i= pars.length; i-- > 0;) {    
                  //idiom for string.startsWith
                  var testvar = pars[i]+" ";
                  if (testvar.lastIndexOf(prefix, 0) !== -1) {  
                      pars.splice(i, 1);
                  }
              }
              url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
          }
        
        }
        window.history.pushState({}, '', url.toString());
        

    }
    
    if (state){
        return <div className={style.quickeasy} onClick={click}><div className={style.quickenabled}>{local.__("Quick")}</div> <div className={style.icondisabled}>{iconDisabled}</div> <div className={style.detaildisabled}>{local.__("Detail")}</div></div>
    }else{
        return <div className={style.quickeasy} onClick={click}><div className={style.quickdisabled}>{local.__("Quick")}</div> <div className={style.iconenabled}>{iconEnabled}</div> <div className={style.detailenabled}>{local.__("Detail")}</div></div>
    
    
    }
}

const Load = () => {
    const local = useLocal()
    const modal = useModal()

    const click = () => {
        modal.openSolutionLoad()
    }
    const solutionRepository = useSolutionRepository()
      if (solutionRepository.count() == 0)
        return null

    return <div className={style.menuItem} onClick={click}>
        {iconLoad}
        {local.__("gespeicherte Räume")}
    </div>
}

const Account = () => {
    const local = useLocal()
    const message = useMessage()

    const click = () => {
        message.showError(local.__("Diese Funktion steht im Moment nicht zur verfügung."))
    }

    return <div className={style.menuItem} onClick={click}>
        {iconLogin}
        {local.__("Log in")}
    </div>
}

const Consult = () => {
    const local = useLocal()
    const modal = useModal()
    const solution = useSolution()
    const solutionRepository = useSolutionRepository()
    const saveName = RoomName()

    const className = solution.getCode()
        ? style.menuItem
        : `${style.menuItem} ${style.disabled}`


    const click = () => {
        if (solution.getCode()) {
            solutionRepository.add(solution.getSavedRoom(), saveName)
            modal.openSolutionLoad()
            solutionDispatchShare(solution.getCode(), true)
        }
    }

    return <div className={className} onClick={click}>
        {iconHeadset}
        {local.__("Beratung")}
    </div>
}

const Help = () => {
    const local = useLocal()
    const modal = useModal()

    const click = () => {
        modal.openHelp()
    }

    return <div style={{position: "relative"}}>
        <div className={style.menuItem} onClick={click}>
            {iconHelp}
            {local.__("Hilfe")}
        </div>
    </div>
}

const Tutorial = () => {
    const modal = useModal()
    const progress = useProgress()
    const [hide, setHide] = useState(false)

    const close = () => {
        setHide(true)
    }

    const click = () => {
        modal.openHelp()
    }

    useEffect(() => {
        document.addEventListener("click", close)
        return () => {
            document.removeEventListener("click", close)
        }
    }, [])

    if (!progress.isRoom() || hide) return null

    return <div className={style.tutorial}>
        <div/>
        <div onClick={click}/>
    </div>
}

